import React from "react";

import {
  useTable,
  useRowSelect,
  useSortBy,
  usePagination,
  useFilters,
} from "react-table";

import { Flex, Table, Tbody, Td, Th, Thead, Tr, Text } from "@chakra-ui/react";

const TableGestao = (props) => {
  const { data, columns } = props;

  const hoje = new Date();

  const initialState = {
    sortBy: [],
  };

  if (props.entidade === "gestora") {
    const todasDatasFimGestaoPassadas = data.every((item) => {
      const dataFimGestao = new Date(item?.dataFim);
      dataFimGestao.setHours(0, 0, 0, 0);
      hoje.setHours(0, 0, 0, 0);
      return dataFimGestao < hoje;
    });

    if (todasDatasFimGestaoPassadas) {
      delete columns[2];
    }

    initialState.sortBy.unshift({ id: "dataInicio", asc: true });
  } else if (props.entidade === "supervisaoExterna") {
    const todasDatasFimSupervisaoPassadas = data.every((item) => {
      const dataFimSupervisao = new Date(item?.dataFim);
      dataFimSupervisao.setHours(0, 0, 0, 0);
      hoje.setHours(0, 0, 0, 0);
      return dataFimSupervisao < hoje;
    });

    if (todasDatasFimSupervisaoPassadas) {
      delete columns[3];
    }
    initialState.sortBy.unshift({ id: "dataFim", asc: true });
  } else if (props.entidade === "supervisaoGestor") {
    const todasDatasFimSupervisaoOGPassadas = data.every((item) => {
      const dataFimSupervisaoOG = new Date(item?.dataFim);
      dataFimSupervisaoOG.setHours(0, 0, 0, 0);
      hoje.setHours(0, 0, 0, 0);
      return dataFimSupervisaoOG < hoje;
    });

    if (todasDatasFimSupervisaoOGPassadas) {
      delete columns[2];
    }
    initialState.sortBy.unshift({ id: "dataFim", asc: true });
  }

  // Table hook with conditional sortBy
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, page } =
    useTable(
      {
        columns,
        data,
        initialState,
      },
      useFilters,
      useSortBy,
      usePagination,
      useRowSelect
    );

  return (
    <Flex overflowX="auto">
      <Table {...getTableProps} backgroundColor="white" mt="25px">
        <Thead backgroundColor="#ECEFF1">
          {headerGroups.map((headerGroup, index) => (
            <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
              {headerGroup.headers.map((column, index) => (
                <Th {...column.getHeaderProps()} key={index} w={"40%"}>
                  <Flex
                    flexDir="row"
                    alignContent="center"
                    justifyContent="start"
                  >
                    <Text
                      textAlign="center"
                      as="p"
                      whiteSpace={
                        column.Header === "Fim da Supervisão" && "nowrap"
                      }
                    >
                      {column.render("Header")}
                    </Text>
                  </Flex>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps}>
          {page.map((row, i) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()} key={i}>
                {row.cells.map((cell, index) => {
                  const image = cell.column.Header === "Estatuto da Entidade";
                  return (
                    <Td
                      w={"40%"}
                      key={index}
                      {...cell.getCellProps()}
                      py="6px"
                      fontWeight={500}
                      fontSize="14px"
                      lineHeight="21.6px"
                      color="#6B6C71"
                      pr={image ? "5%" : ""}
                      textAlign={image ? "center" : "start"}
                    >
                      {cell.render("Cell")}
                    </Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </Flex>
  );
};

export default TableGestao;
